import Button from '@components/interactive/Button';
import { Box, Divider, Flex, Tag, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { DashboardItem, ItemType } from './types';

type Props = {
  item: DashboardItem;
  orderItem?: any;
  onItemClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const getPlaceholderGradient = (item: DashboardItem) => {
  if (item.tags.includes('Allergy')) {
    return 'linear(to-b, blue.200, white)';
  }

  if (item.tags.includes('First Aid') || item.tags.includes('Pain')) {
    return 'linear(to-b, red.200, white)';
  }

  if (item.tags.includes('Vitamins')) {
    return 'linear(to-b, orange.200, white)';
  }

  if (item.tags.includes("Women's")) {
    return 'linear(to-b, pink.200, white)';
  }

  if (item.tags.includes('Personal')) {
    return 'linear(to-b, green.200, white)';
  }

  return 'linear(to-b, gray.200, white)';
};

export const ITEM_WIDTHS = { base: '100%', md: 350, xl: 400 };
const IMAGE_WIDTH = 300;

const Item = ({ item, orderItem, onItemClick }: Props) => {
  return (
    <Box borderRadius={5} border="1px solid rgba(52, 95, 235, 0.1)" boxShadow="0 0 10px 10px rgba(2, 64, 238, 0.03)">
      <Divider mb={2} w="unset" opacity={1} borderRadius="20px 20px 0 0" borderColor="blue.500" borderWidth="4px" />
      <Flex p={8} direction="column">
        <Box h={120} mb={5}>
          {item.type === ItemType.COLLECTION ? (
            <Tag mb={5} fontWeight="bold" colorScheme="green">
              Popular
            </Tag>
          ) : null}
          <Text fontSize="xl" fontWeight={600}>
            {item.title}
          </Text>
          <Text pb={2} fontSize="sm">
            {item.subtitle}
          </Text>
          <Text color="gray.500" fontWeight="bold" fontSize="sm">
            {item.count_description}
          </Text>
        </Box>
        <Flex mb={5} overflow="hidden" w="100%" h={IMAGE_WIDTH}>
          <Flex borderRadius={5} backgroundColor="gray.100" overflow="hidden" margin="auto">
            {item.image_url ? (
              <Image alt={item.title} width={IMAGE_WIDTH} height={IMAGE_WIDTH} src={item.image_url} />
            ) : (
              <Box bgGradient={getPlaceholderGradient(item)} width={IMAGE_WIDTH} height={IMAGE_WIDTH} />
            )}
          </Flex>
        </Flex>
        <Text fontSize={30} fontWeight="bold" pb={5}>
          {`$${item.price}`}
        </Text>
        <Button id={`add_item_${item.id}`} data-item={item.id} onClick={onItemClick} width="100%" margin="auto">
          {orderItem ? `Add (${orderItem.count} in cart)` : 'Add'}
        </Button>
      </Flex>
    </Box>
  );
};

export default Item;
